var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAureaLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "181.845549px",
    height: "43.9996178px",
    viewBox: "0 0 181.845549 43.9996178",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 44 181.845549 44 181.845549 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MERCADO-SECUND\\xC1RIO",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-18, -78.0003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(18, 78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#DCAA5A",
    points: "0 43.4642257 10.6700979 43.4642257 15.9800638 30.5270962 10.644776 17.5675115"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#1E1E1C",
    points: "21.3147784 17.567177 15.9799683 30.5267618 21.3143006 43.464369 31.9848763 43.464369"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#AC793D",
    points: "10.6449193 17.567177 15.9797294 30.5267618 21.3145395 17.567177"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#DCAA5A",
    points: "17.8000912 0.000286663626 23.1349013 12.9598714 28.4701892 0.000286663626"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#AC793D",
    points: "21.3147784 17.589489 15.9799683 4.62990423 10.6451582 17.589489"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1406606,27.8897909 C52.7845679,27.8897909 56.8475471,25.0217213 56.8475471,19.0939953 C56.8475471,14.2656243 53.1667861,10.5848633 47.8133429,10.5848633 L38.7318392,10.5848633 L38.7318392,27.8897909 L46.1406606,27.8897909 Z M37.250266,9.29392143 L47.9571525,9.29392143 C54.6010598,9.29392143 58.4246748,13.5962647 58.4246748,19.0939953 C58.4246748,25.2606076 53.9317002,29.1807327 46.7622429,29.1807327 L38.7318392,29.1807327 L38.7318392,43.3787044 L37.250266,43.3787044 L37.250266,9.29392143 Z",
    id: "Fill-7",
    fill: "#1E1E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9126805,27.8897909 C80.5565878,27.8897909 84.619567,25.0217213 84.619567,19.0939953 C84.619567,14.2656243 80.938806,10.5848633 75.5853628,10.5848633 L66.5038591,10.5848633 L66.5038591,27.8897909 L73.9126805,27.8897909 Z M65.0222859,9.29392143 L75.7291724,9.29392143 C82.3730797,9.29392143 86.1966947,13.5962647 86.1966947,19.0939953 C86.1966947,25.2606076 81.7037201,29.1807327 74.5342628,29.1807327 L66.5038591,29.1807327 L66.5038591,43.3787044 L65.0222859,43.3787044 L65.0222859,9.29392143 Z",
    id: "Fill-9",
    fill: "#1E1E1C"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#1E1E1C",
    points: "92.7943058 9.29392143 94.275879 9.29392143 94.275879 42.0399852 112.917137 42.0399852 112.917137 43.3787044 92.7943058 43.3787044"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#1E1E1C",
    mask: "url(#mask-2)",
    points: "118.845962 43.3788955 120.327535 43.3788955 120.327535 9.29411254 118.845962 9.29411254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.640658,32.9571438 L127.640658,20.1934458 C127.640658,13.6919148 132.564106,8.57688014 139.97245,8.57688014 C146.998575,8.57688014 151.348218,12.8792234 151.348218,17.8987035 L151.348218,20.1456686 L149.914422,20.1456686 L149.914422,18.3291767 C149.914422,13.5963602 146.520803,10.0111538 139.733564,10.0111538 C133.232988,10.0111538 129.217786,14.5046062 129.217786,20.3845549 L129.217786,32.431116 C129.217786,38.6459835 133.328543,42.6611853 139.97245,42.6611853 C146.759689,42.6611853 149.914422,39.0282016 149.914422,34.2958629 L149.914422,33.2915847 L151.348218,33.2915847 L151.348218,34.7736356 C151.348218,40.1275566 147.046353,43.9999044 139.97245,43.9999044 C132.85077,43.9999044 127.640658,40.2713662 127.640658,32.9571438",
    id: "Fill-15",
    fill: "#1E1E1C",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.345021,29.8020761 L168.510005,10.871288 L168.462228,10.871288 L161.436102,29.8020761 L175.345021,29.8020761 Z M167.792868,9.10257346 L169.322696,9.10257346 L181.845597,43.3784655 L180.268469,43.3784655 L175.775017,31.0925402 L161.005629,31.0925402 L156.512654,43.3784655 L155.031081,43.3784655 L167.792868,9.10257346 Z",
    id: "Fill-16",
    fill: "#1E1E1C",
    mask: "url(#mask-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(0, 0.0003)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#DCAA5A",
    points: "0 43.4517587 10.6671078 43.4517587 15.9755856 30.5182547 10.6417929 17.5623018"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#1E1E1C",
    points: "21.3088051 17.5619674 15.9754901 30.5179204 21.3083275 43.451902 31.9759129 43.451902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#AC793D",
    points: "10.6419362 17.5619674 15.9752513 30.5179204 21.3085663 17.5619674"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#DCAA5A",
    points: "17.7951029 0 23.128418 12.955953 28.4622107 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#AC793D",
    points: "21.3088051 17.5842731 15.9754901 4.62832016 10.642175 17.5842731"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAureaLogo);
export default __webpack_public_path__ + "static/media/AUREA_logo.0378350dcbfd1bf1eedddabbdc656e1a.svg";
export { ForwardRef as ReactComponent };